export default __webpack_public_path__ + "static/media/miss-you.cd394263.gif";